import {
  DrawerFooterArea,
  Drawer as DrawerType,
  ControlcenterMelcoModelsLicenseCreateResponse,
} from "melco-shared-logic";
import {
  Col,
  Drawer,
  FullWidthSpace,
  Row,
  Steps,
  DesignTokens,
} from "melco-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CreateMachineLicensesForm,
  CreateMachineLicensesFormValueType,
} from "../form/machinelicenses/create/CreateMachineLicensesForm";
import { CreateMachineLicensesSummary } from "../form/machinelicenses/create/CreateMachineLicensesSummary";
import { CopyMachineLicenses } from "../form/machinelicenses/create/CopyMachineLicenses";

const { spacings } = DesignTokens;

type CreateMachineLicensesDrawerProps = {
  drawer: DrawerType;
};

export const CreateMachineLicensesDrawer: React.FC<
  CreateMachineLicensesDrawerProps
> = ({ drawer }) => {
  const { t } = useTranslation();
  const { closeDrawer, isDrawerOpen } = drawer;
  const [currentStep, setCurrentStep] = useState(0);
  const [licenseFormValues, setLicenseFormValues] =
    useState<CreateMachineLicensesFormValueType>();
  const [licenseDisplayValues, setLicenseDisplayValues] = useState<any>();
  const [createMachineLicensesResponse, setCreateMachineLicensesResponse] =
    useState<ControlcenterMelcoModelsLicenseCreateResponse>();
  const onCloseDrawer = () => {
    setCurrentStep(0);
    setLicenseFormValues({
      number_of_machines: 0,
      license_key: "",
      product_code: "SUMMIT_MANAGER",
      sub_type: "",
      // version_id: "",
      email_address: "",
      // version_number: "",
      language: "",
      melco_customer_id: "",
    });
    setLicenseDisplayValues({
      subscription_code_label: "",
      product_code_label: "",
      version_number_label: "",
      language: "",
    });
    closeDrawer();
  };

  const callBackStep2Fn = (
    obj: ControlcenterMelcoModelsLicenseCreateResponse | undefined
  ) => {
    console.log(obj);
    setCreateMachineLicensesResponse(obj);
    setCurrentStep(currentStep + 1);
  };

  const stepback = () => {
    setCurrentStep(currentStep - 1);
  };

  const callBackStep1Fn = (
    values: CreateMachineLicensesFormValueType,
    displayValues: any
  ) => {
    setLicenseFormValues(values);
    setCurrentStep(currentStep + 1);
    setLicenseDisplayValues(displayValues);
  };

  const forms: any = [
    <CreateMachineLicensesForm
      onCreateMachineLicensesCallBackFn={callBackStep1Fn}
      machineLicensesFormValues={licenseFormValues}
      machineLicensesDisplayValues={licenseDisplayValues}
    />,

    <CreateMachineLicensesSummary
      stepback={stepback}
      callbackFn={callBackStep2Fn}
      machineLicensesFormValues={licenseFormValues}
      machineLicensesDisplayValues={licenseDisplayValues}
    />,

    <CopyMachineLicenses
      successMessage={t(
        "machinelicenses.create.copy.message"
      ).replace("[email]", licenseFormValues?.email_address ?? "")}
      createMachineLicensesResponse={createMachineLicensesResponse}
      onCloseDrawer={onCloseDrawer}
      machineLicensesFormvalues={licenseFormValues}
      title={t("machinelicenses.copylicense.title")}
    />,
  ];

  // isDrawerOPen is used multiple times to display UI, basically to refresh DOM and build components in DOM again
  // As Footer section was becoming empty if go from one Drawer to other like Create Drawer, Upgrade Drawer, Change Level Drawer

  return (
    <>
      {isDrawerOpen && (
        <Drawer
          title={"Create machine licenses"}
          placement="right"
          width={1000}
          closable={true}
          onClose={onCloseDrawer}
          open={isDrawerOpen}
          footer={isDrawerOpen && <DrawerFooterArea />}
        >
          <FullWidthSpace direction="vertical">
            <Steps
              items={[
                {
                  title: t("licensemanager.create.steps.licensedetail"),
                },

                {
                  title: t("licensemanager.create.steps.summary"),
                },
                {
                  title: "Finish",
                },
              ]}
              current={currentStep}
              labelPlacement="vertical"
              size="small"
            />

            <FullWidthSpace direction="vertical" size="middle">
              {/* <Title level={4}>Define customer & license details</Title> */}

              <div>
                <Row gutter={[spacings.middle, 0]}>
                  <Col xs={24} md={24}>
                    {isDrawerOpen && forms[currentStep]}
                  </Col>
                </Row>
              </div>
            </FullWidthSpace>
          </FullWidthSpace>
        </Drawer>
      )}
    </>
  );
};
